import {processTimingEvent} from 'performance/BenchlingProfiler';

import {EventMetadata, ProfilerEvent, ProfilerEventDomain} from './ProfilerConstants';

const DOMAIN = ProfilerEventDomain.RESULTS;
/* Should bump version anytime there's a change to logging events or processing them,
 * so that on Datadog, we can quickly see which custom actions have outdated logic or tags
 */
const PROFILER_RESULTS_EVENTS_VERSION = 0;

enum ProfilerResultsFeatures {
  LOAD_RESULTS_TAB = 'loadResultsTab',
}

enum ProfilerResultsActions {
  LOAD_RESULTS_TAB_STARTED = 'loadResultsTabStarted',
  LOAD_RESULTS_TAB_FINISHED = 'loadResultsTabFinished',
}

/**
 * Only `FINISHED` events need to be processed.
 */
const FINISHED_ACTION_TO_PROCESSING_FUNCTION: {[key in ProfilerResultsActions]?: Function} = {
  [ProfilerResultsActions.LOAD_RESULTS_TAB_FINISHED]: processLoadResultsTab,
};

export const LOAD_RESULTS_TAB_STARTED_EVENT: ProfilerEvent = {
  domain: DOMAIN,
  feature: ProfilerResultsFeatures.LOAD_RESULTS_TAB,
  action: ProfilerResultsActions.LOAD_RESULTS_TAB_STARTED,
};

export const LOAD_RESULTS_TAB_FINISHED_EVENT: ProfilerEvent = {
  domain: DOMAIN,
  feature: ProfilerResultsFeatures.LOAD_RESULTS_TAB,
  action: ProfilerResultsActions.LOAD_RESULTS_TAB_FINISHED,
};

function getBucket(value: number, bucketCutoffs: Array<number>): string {
  const max = bucketCutoffs.find((cutoff) => cutoff > value) ?? 'max';
  const min = bucketCutoffs.findLast((cutoff) => cutoff <= value) ?? 'min';
  return `${min}-to-${max}`;
}

export function getLoadResultsTabExtraMetadata(numResults: number, numSchemas: number): EventMetadata {
  return {
    // Bucket `distributionMetadata` to reduce DataDog cost
    distributionMetadata: {
      num_results: getBucket(numResults, [0, 100, 1_000, 10_000]),
      num_schemas: getBucket(numSchemas, [0, 10, 100]),
    },
    actionMetadata: {},
  };
}

export function processResultsEvents(profilerEvent: ProfilerEvent): void {
  FINISHED_ACTION_TO_PROCESSING_FUNCTION[profilerEvent.action as ProfilerResultsActions]?.(profilerEvent);
}

function processLoadResultsTab(profilerFinishedEvent: ProfilerEvent): void {
  const {id} = profilerFinishedEvent;
  processTimingEvent(
    {...LOAD_RESULTS_TAB_STARTED_EVENT, id},
    {...LOAD_RESULTS_TAB_FINISHED_EVENT, id},
    'Load Results Tab',
    'perf.load_results_tab',
    PROFILER_RESULTS_EVENTS_VERSION
  );
}
